import * as types from './types';
export function setTelemetryCustom(custom) {
    return function (dispatch) {
        dispatch({ type: types.SET_TELEMETRY_CUSTOM, payload: custom });
    };
}
export function setTelemetryUser(user) {
    return function (dispatch) {
        dispatch({ type: types.SET_TELEMETRY_USER, payload: user });
    };
}
export function setTelemetryLabels(labels) {
    return function (dispatch) {
        dispatch({ type: types.SET_TELEMETRY_LABELS, payload: labels });
    };
}
